import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הקול שמחפש אישור",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה להפסיק לחפש אישור. אני מזהה מתי זה קורה."
    ],
      [
      "היום אני לא מנסה להפסיק לחפש אישור. אני מזהה מתי זה קורה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "בלב: “זה הצורך באישור. הוא לא אני.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "בלב: “זה הצורך באישור. הוא לא אני.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מתי היום הכי חשוב לי מה יחשבו עליי?\n[כאן אני כותב]",
      "2. איזה פחד יושב מתחת לזה? (דחייה / בושה / לא להיות שייך)\n[כאן אני כותב]",
      "3. איפה בגוף אני מרגיש את הצורך הזה?\n[כאן אני כותב]"
    ],
      [
      "1. מתי היום הכי חשוב לי מה יחשבו עליי?\n[כאן אני כותב]",
      "2. איזה פחד יושב מתחת לזה? (דחייה / בושה / לא להיות שייך)\n[כאן אני כותב]",
      "3. איפה בגוף אני מרגיש את הצורך הזה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לחפש אישור זה מנגנון הגנה, לא חולשה."
    ],
      [
      "סגירה",
      "לחפש אישור זה מנגנון הגנה, לא חולשה."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: נשימה + “שמתי לב לצורך, לא פעלתי לפיו.”",
      "פעם אחת היום: נשימה + “שמתי לב לצורך, לא פעלתי לפיו.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "עובדה מול דמיון (“מה באמת יקרה?”)",
    opening: localizedGenderNode(
      [
      "היום אני מפריד בין פחד לבין מציאות."
    ],
      [
      "היום אני מפריד בין פחד לבין מציאות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה אני מפחד שיגידו עליי?\n[כאן אני כותב]",
      "2. מה הראיות שיש לזה באמת?\n[כאן אני כותב]",
      "3. מה סביר יותר שיקרה במציאות?\n[כאן אני כותב]"
    ],
      [
      "1. מה אני מפחד שיגידו עליי?\n[כאן אני כותב]",
      "2. מה הראיות שיש לזה באמת?\n[כאן אני כותב]",
      "3. מה סביר יותר שיקרה במציאות?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "המוח מגזים כדי להגן — לא כדי לדייק."
    ],
      [
      "סגירה",
      "המוח מגזים כדי להגן — לא כדי לדייק."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה “מה יגידו” — אני שואל: “יש לזה הוכחה?”",
      "כשעולה “מה יגידו” — אני שואל: “יש לזה הוכחה?”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "המחיר של לחיות בשביל אישור",
    opening: localizedGenderNode(
      [
      "היום אני רואה מה זה גובה ממני."
    ],
      [
      "היום אני רואה מה זה גובה ממני."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איפה אני מתנהג אחרת כדי שיאהבו אותי?\n[כאן אני כותב]",
      "2. מה אני מוותר עליי כשאני עושה את זה?\n[כאן אני כותב]",
      "3. איך זה מרגיש בגוף אחרי שאני “מרצה”?\n[כאן אני כותב]"
    ],
      [
      "1. איפה אני מתנהג אחרת כדי שיאהבו אותי?\n[כאן אני כותב]",
      "2. מה אני מוותר עליי כשאני עושה את זה?\n[כאן אני כותב]",
      "3. איך זה מרגיש בגוף אחרי שאני “מרצה”?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אישור מבחוץ לפעמים קונה שקט רגעי — וגובה זהות."
    ],
      [
      "סגירה",
      "אישור מבחוץ לפעמים קונה שקט רגעי — וגובה זהות."
    ]
    ),
    action: localizedGenderNode(
      "אני שם לב פעם אחת שאני מרצה — בלי לתקן.",
      "אני שם לב פעם אחת שאני מרצה — בלי לתקן."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "מאיפה זה התחיל",
    opening: localizedGenderNode(
      [
      "היום אני מזהה שורש, בלי להאשים."
    ],
      [
      "היום אני מזהה שורש, בלי להאשים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מתי למדתי שבוחר/ת אישור כדי להיות בסדר?\n[כאן אני כותב]",
      "2. מי לימד אותי את זה — במילים או בהתנהגות?\n[כאן אני כותב]",
      "3. מה הייתי בוחר/ת אז ולא קיבלתי?\n[כאן אני כותב]"
    ],
      [
      "1. מתי למדתי שבוחר/ת אישור כדי להיות בסדר?\n[כאן אני כותב]",
      "2. מי לימד אותי את זה — במילים או בהתנהגות?\n[כאן אני כותב]",
      "3. מה הייתי בוחר/ת אז ולא קיבלתי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "מה שנלמד — אפשר גם ללמוד מחדש."
    ],
      [
      "סגירה",
      "מה שנלמד — אפשר גם ללמוד מחדש."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד לעצמי הצעיר/ה: “לא היית בוחר/ת להוכיח.”",
      "משפט אחד לעצמי הצעיר/ה: “לא היית בוחר/ת להוכיח.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "לזהות ריצוי בזמן אמת",
    opening: localizedGenderNode(
      [
      "היום אני מאט לפני “כן”."
    ],
      [
      "היום אני מאט לפני “כן”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איפה הכי קשה לי להגיד “לא”?\n[כאן אני כותב]",
      "2. מה אני מפחד שיקרה אם אסרב?\n[כאן אני כותב]",
      "3. מה יקרה לי אם אמשיך להגיד “כן” על חשבוני?\n[כאן אני כותב]"
    ],
      [
      "1. איפה הכי קשה לי להגיד “לא”?\n[כאן אני כותב]",
      "2. מה אני מפחד שיקרה אם אסרב?\n[כאן אני כותב]",
      "3. מה יקרה לי אם אמשיך להגיד “כן” על חשבוני?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לפני “כן” לאחרים — יש “כן” לעצמי."
    ],
      [
      "סגירה",
      "לפני “כן” לאחרים — יש “כן” לעצמי."
    ]
    ),
    action: localizedGenderNode(
      "לפני תשובה: נשימה אחת + “מה נכון לי?”",
      "לפני תשובה: נשימה אחת + “מה נכון לי?”"
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "אישור מול חיבור אמיתי",
    opening: localizedGenderNode(
      [
      "היום אני מבדיל בין אהבה לריצוי."
    ],
      [
      "היום אני מבדיל בין אהבה לריצוי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. עם מי אני מרגיש חיבור גם בלי להרשים?\n[כאן אני כותב]",
      "2. איך זה מרגיש בגוף להיות פשוט אני?\n[כאן אני כותב]",
      "3. מה זה מלמד אותי על קשרים?\n[כאן אני כותב]"
    ],
      [
      "1. עם מי אני מרגיש חיבור גם בלי להרשים?\n[כאן אני כותב]",
      "2. איך זה מרגיש בגוף להיות פשוט אני?\n[כאן אני כותב]",
      "3. מה זה מלמד אותי על קשרים?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "חיבור אמיתי לא דורש הופעה."
    ],
      [
      "סגירה",
      "חיבור אמיתי לא דורש הופעה."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר אדם אחד להיות איתו פשוט.",
      "אני בוחר אדם אחד להיות איתו פשוט."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "ניסוי קטן (Behavior)",
    opening: localizedGenderNode(
      [
      "היום אני עושה דבר קטן בלי לבדוק תגובות."
    ],
      [
      "היום אני עושה דבר קטן בלי לבדוק תגובות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזו פעולה אני נמנע ממנה מחשש לדעה של אחרים?\n[כאן אני כותב]",
      "2. מה גרסת ה־10% שלה?\n[כאן אני כותב]",
      "3. מה אני רוצה להרגיש אחרי?\n[כאן אני כותב]"
    ],
      [
      "1. איזו פעולה אני נמנע ממנה מחשש לדעה של אחרים?\n[כאן אני כותב]",
      "2. מה גרסת ה־10% שלה?\n[כאן אני כותב]",
      "3. מה אני רוצה להרגיש אחרי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה"
    ],
      [
      "סגירה"
    ]
    ),
    action: localizedGenderNode(
      "פעולה קטנה להיום",
      "פעולה קטנה להיום"
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "לשאת אי־נוחות (ACT)",
    opening: localizedGenderNode(
      [
      "היום אני נשאר עם אי־נוחות בלי לברוח לאישור."
    ],
      [
      "היום אני נשאר עם אי־נוחות בלי לברוח לאישור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזו תחושה עולה כשאני לא מקבל אישור?\n[כאן אני כותב]",
      "2. תרגול דקה: אני נותן לתחושה להיות. מה קורה?\n[כאן אני כותב]",
      "3. מה גיליתי על הגל?\n[כאן אני כותב]"
    ],
      [
      "1. איזו תחושה עולה כשאני לא מקבל אישור?\n[כאן אני כותב]",
      "2. תרגול דקה: אני נותן לתחושה להיות. מה קורה?\n[כאן אני כותב]",
      "3. מה גיליתי על הגל?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אי־נוחות היא גל — לא סכנה."
    ],
      [
      "סגירה",
      "אי־נוחות היא גל — לא סכנה."
    ]
    ),
    action: localizedGenderNode(
      "דקה אחת בלבד. עקביות > כוח.",
      "דקה אחת בלבד. עקביות > כוח."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "הקול שמבקר אותי מבפנים",
    opening: localizedGenderNode(
      [
      "היום אני מזהה שהמבקר מחליף אישור חיצוני."
    ],
      [
      "היום אני מזהה שהמבקר מחליף אישור חיצוני."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה המבקר אומר כשאין אישור?\n[כאן אני כותב]",
      "2. איך הייתי מדבר לחבר במקומי?\n[כאן אני כותב]",
      "3. איזה משפט רך אני בוחר היום?\n[כאן אני כותב]"
    ],
      [
      "1. מה המבקר אומר כשאין אישור?\n[כאן אני כותב]",
      "2. איך הייתי מדבר לחבר במקומי?\n[כאן אני כותב]",
      "3. איזה משפט רך אני בוחר היום?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה להעניש את עצמי כשאחרים שותקים."
    ],
      [
      "סגירה",
      "אני לא רוצה להעניש את עצמי כשאחרים שותקים."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה מבקר — משפט רך אחד בלבד.",
      "כשעולה מבקר — משפט רך אחד בלבד."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "גבול מול “מה יגידו”",
    opening: localizedGenderNode(
      [
      "היום אני מציב גבול פנימי."
    ],
      [
      "היום אני מציב גבול פנימי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איפה “מה יגידו” מנהל אותי הכי חזק?\n[כאן אני כותב]",
      "2. איזה גבול קטן אני מוכן לשים השבוע?\n[כאן אני כותב]",
      "3. מה הפחד סביב הגבול הזה?\n[כאן אני כותב]"
    ],
      [
      "1. איפה “מה יגידו” מנהל אותי הכי חזק?\n[כאן אני כותב]",
      "2. איזה גבול קטן אני מוכן לשים השבוע?\n[כאן אני כותב]",
      "3. מה הפחד סביב הגבול הזה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "גבול לא מרחיק אהבה — הוא מגן עליי."
    ],
      [
      "סגירה",
      "גבול לא מרחיק אהבה — הוא מגן עליי."
    ]
    ),
    action: localizedGenderNode(
      "פעולה אחת שמכבדת את הגבול.",
      "פעולה אחת שמכבדת את הגבול."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "ערך עצמי בלי קהל",
    opening: localizedGenderNode(
      [
      "היום אני שואל מי אני כשאף אחד לא מסתכל."
    ],
      [
      "היום אני שואל מי אני כשאף אחד לא מסתכל."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה אני אוהב בעצמי בלי קשר לדעה של אחרים?\n[כאן אני כותב]",
      "2. איפה אני מרגיש יציב גם לבד?\n[כאן אני כותב]",
      "3. איך זה מרגיש בגוף?\n[כאן אני כותב]"
    ],
      [
      "1. מה אני אוהב בעצמי בלי קשר לדעה של אחרים?\n[כאן אני כותב]",
      "2. איפה אני מרגיש יציב גם לבד?\n[כאן אני כותב]",
      "3. איך זה מרגיש בגוף?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הערך שלי לא תלוי בצופים."
    ],
      [
      "סגירה",
      "הערך שלי לא תלוי בצופים."
    ]
    ),
    action: localizedGenderNode(
      "זמן קצר לבד — בלי תיעוד, בלי שיתוף.",
      "זמן קצר לבד — בלי תיעוד, בלי שיתוף."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "לשנות שפה פנימית",
    opening: localizedGenderNode(
      [
      "היום אני מחליף “צריכים לאשר אותי” ב”אני בוחר אותי”."
    ],
      [
      "היום אני מחליף “צריכים לאשר אותי” ב”אני בוחר אותי”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזו אמונה ישנה מנהלת אותי?\n[כאן אני כותב]",
      "2. איך היא נשמעת בשפה רכה ובריאה יותר?\n[כאן אני כותב]",
      "3. איזה משפט אני מאמץ לשבוע?\n[כאן אני כותב]"
    ],
      [
      "1. איזו אמונה ישנה מנהלת אותי?\n[כאן אני כותב]",
      "2. איך היא נשמעת בשפה רכה ובריאה יותר?\n[כאן אני כותב]",
      "3. איזה משפט אני מאמץ לשבוע?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "שפה יוצרת מציאות."
    ],
      [
      "סגירה",
      "שפה יוצרת מציאות."
    ]
    ),
    action: localizedGenderNode(
      "אני משתמש במשפט החדש פעם אחת.",
      "אני משתמש במשפט החדש פעם אחת."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "לבחור כיוון פנימי",
    opening: localizedGenderNode(
      [
      "היום אני מגדיר כיוון, לא תגובה."
    ],
      [
      "היום אני מגדיר כיוון, לא תגובה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזה ערך חשוב לי יותר מאישור?\n[כאן אני כותב]",
      "2. איך הוא נראה בהתנהגות קטנה?\n[כאן אני כותב]",
      "3. מה אני מבטיח לעצמי ברגע של ספק?\n[כאן אני כותב]"
    ],
      [
      "1. איזה ערך חשוב לי יותר מאישור?\n[כאן אני כותב]",
      "2. איך הוא נראה בהתנהגות קטנה?\n[כאן אני כותב]",
      "3. מה אני מבטיח לעצמי ברגע של ספק?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "כיוון פנימי חזק מרעש חיצוני."
    ],
      [
      "סגירה",
      "כיוון פנימי חזק מרעש חיצוני."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר פעולה אחת לפי הערך.",
      "אני בוחר פעולה אחת לפי הערך."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים עם נאמנות לעצמי."
    ],
      [
      "היום אני מסיים עם נאמנות לעצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה השתנה בי במסע הזה?\n[כאן אני כותב]",
      "2. מה נהיה ברור לגבי אישור?\n[כאן אני כותב]",
      "3. משפט חזרה לימים קשים:\n[כאן אני כותב]"
    ],
      [
      "1. מה השתנה בי במסע הזה?\n[כאן אני כותב]",
      "2. מה נהיה ברור לגבי אישור?\n[כאן אני כותב]",
      "3. משפט חזרה לימים קשים:\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני יכול להקשיב לאחרים —",
      "בלי לוותר עליי.",
      "אני ממשיך ללכת",
      "עם הקול שלי.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "אני יכול להקשיב לאחרים —",
      "בלי לוותר עליי.",
      "אני ממשיך ללכת",
      "עם הקול שלי.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "פעולה אחת שמסמלת: “אני בעדי”.",
      "פעולה אחת שמסמלת: “אני בעדי”."
    ),
  },
].map(buildNormalizedDay);

export const dependenceOnExternalApprovalBlueprintHe = buildNormalizedPilotBlueprint({
  id: "dependence_on_external_approval_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "dependence_on_external_approval",
  category: "general",
  journeyName: {
    he: "תלות באישור מבחוץ",
    en: "Dependence on External Approval",
    es: "Dependencia de la Aprobación Externa",
  },
  days,
});

export default dependenceOnExternalApprovalBlueprintHe;
